import { useEffect, useRef, useState } from 'react';
import { Award, Clock3, Headset, Leaf, Settings, ShieldCheck } from 'lucide-react';
import { BenefitsBackground, BenefitsPoster } from './BenefitsBackground';
import './Benefits.css';

const BENEFITS = [
  { title: 'Zuverlässigkeit', text: 'Pünktlich, professionell und verlässlich – auf uns können Sie sich zu 100% verlassen.', icon: ShieldCheck },
  { title: 'Flexibilität', text: 'Schnelle Reaktionszeiten und flexible Einsatzplanung nach Ihren Wünschen.', icon: Clock3 },
  { title: 'Qualität', text: 'Höchste Standards durch geschultes Fachpersonal und moderne Ausrüstung.', icon: Award },
  { title: 'Nachhaltigkeit', text: 'Umweltbewusstes Handeln mit ökologischen Reinigungsmitteln und Prozessen.', icon: Leaf },
  { title: '24/7 Erreichbarkeit', text: 'Rund um die Uhr für Sie da – auch in Notfällen und bei kurzfristigen Anfragen.', icon: Headset },
  { title: 'Maßgeschneidert', text: 'Individuelle Lösungen, die exakt auf Ihre Anforderungen zugeschnitten sind.', icon: Settings },
];

export const Benefits = () => {
  const sectionRef = useRef(null);
  const [loadVideo, setLoadVideo] = useState(false);

  useEffect(() => {
    // The original upload is 124 MB. Only the optimized viewport variant is
    // requested, and only when this section approaches the screen.
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setLoadVideo(true);
      observer.disconnect();
    }, { rootMargin: '240px 0px', threshold: 0 });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return <section ref={sectionRef} className="benefits-experience" id="ihre-vorteile" data-testid="benefits-section" aria-labelledby="benefits-heading-title">
    <div className="benefits-background" data-testid="benefits-background" aria-hidden="true">
      {loadVideo ? <BenefitsBackground /> : <BenefitsPoster />}
      <div className="benefits-background-wash" />
    </div>
    <div className="benefits-content" data-testid="benefits-content">
      <header className="benefits-heading-block">
        <img className="benefits-brand" src="/images/betaris-logo.webp" alt="betaris Glanzwerk" width="1188" height="552" decoding="async" loading="lazy" data-testid="benefits-logo" />
        <h2 id="benefits-heading-title" data-testid="benefits-heading">wir sind Ihr verlässlicher Partner für erstklassige Qualität und nachhaltigen Erfolg.</h2>
      </header>
      <ul className="benefits-grid" data-testid="benefits-grid">
        {BENEFITS.map(({ title, text, icon: Icon }, index) => <li key={title} className="benefits-card" tabIndex={0}
          data-testid={`benefits-card-${index}`} aria-labelledby={`benefits-title-${index}`} aria-describedby={`benefits-description-${index}`}>
          <span className="benefits-icon" data-testid={`benefits-icon-${index}`} aria-hidden="true"><Icon size={27} strokeWidth={1.7} /></span>
          <h3 id={`benefits-title-${index}`} data-testid={`benefits-card-title-${index}`}>{title}</h3>
          <p id={`benefits-description-${index}`} data-testid={`benefits-card-text-${index}`}>{text}</p>
        </li>)}
      </ul>
    </div>
  </section>;
};